function startCountdown() {
  var els = document.querySelectorAll(".clock");
  els.length && els.forEach(addCountdown);
}

function addCountdown(el) {
  var currentDate = new Date();
  var date = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate(),
    23 - currentDate.getHours(),
    59 - currentDate.getMinutes(),
    60 - currentDate.getSeconds()
  );

  var clock = new FlipClock(el, date, {
    face: "TwentyFourHourClock",
    countdown: true,
  });
}

function removeCountdown(el) {
  el && el.html("");
}

startCountdown();

document.addEventListener("shopify:section:load", (e) => {
  let clockEle = $("#shopify-section-" + e.detail.sectionId);
  if (clockEle) {
    addCountdown(clockEle.find(".clock")[0]);
    let sw = clockEle.find(".flash__sale-section")[0];
    if (sw) {
      new Swiper(
        "#shopify-section-" +
          e.detail.sectionId +
          " .flash__sale-section .swiper-container",
        {
          autoplay: false,
          slidesPerView: 4,
          paginationClickable: true,
          spaceBetween: 20,
          navigation: {
            nextEl: ".flash__sale-next",
            prevEl: ".flash__sale-prev",
          },
          //freeMode: true,
          loop: true,
          loopedSlides: 6,
        }
      );
    }
  }
});
document.addEventListener("shopify:section:reorder", (e) => {
  console.log("shopify:section:reorder");
});
document.addEventListener("shopify:section:unload", (e) => {
  if ($(this).find(".clock").length) removeCountdown($(this).find(".clock"));
});

let mySwiper = new Swiper(".flash__sale-section .swiper-container", {
  autoplay: false,
  slidesPerView: 4,
  paginationClickable: true,
  spaceBetween: 20,
  navigation: {
    nextEl: ".flash__sale-next",
    prevEl: ".flash__sale-prev",
  },
  //freeMode: true,
  loop: true,
  loopedSlides: 6,
});

$(window).resize(function () {
  if ($(".flash__sale-section").length) {
    var ww = $(window).width();
    if (ww >= 1000) mySwiper.params.slidesPerView = 4;
    if (ww < 1000) mySwiper.params.slidesPerView = 2;
    mySwiper.update();
  }
});
$(window).trigger("resize");

$( document ).ready(function() {
  if($('.toclick')) {
    $('.toclick').click();
  };
  if($('.h-wa')) {
    $('.h-wa').on('click', function() {
      gtag('event', 'whatsapp-icon-click', {
        'event_label': 'whatsapp icon click',
        'event_category': 'button click',
        'non_interaction': true
      })
    })
  }
});

